import { ExActionTree } from "vuex";
import { State, Actions, Getters, Mutations } from "./types";
import * as api from "@/api";

const actions: ExActionTree<State, Actions, Getters, Mutations> = {
  async createPlan(ctx, payload) {
    try {
      // @ts-ignore TODO: 後で型指定する
      await api.createPlan(payload);
      ctx.commit("createPlanSuccess");
    } catch (error) {
      ctx.commit("createPlanFailed");
      throw error;
    }
  },
  async createEvent(ctx, payload) {
    try {
      // @ts-ignore TODO: 後で型指定する
      await api.createEvent(payload);
      ctx.commit("createEventSuccess");
    } catch (error) {
      ctx.commit("createEventFailed");
      throw error;
    }
  },
  async updateEvent(ctx, payload) {
    try {
      await api.updateEvent(payload);
      ctx.commit("updateEventSuccess");
    } catch (error) {
      ctx.commit("updateEventFailed");
      throw error;
    }
  },
  async deleteEvent(ctx, payload) {
    try {
      await api.deleteEvent(payload);
      ctx.commit("deleteEventSuccess");
    } catch (error) {
      ctx.commit("deleteEventFailed");
      throw error;
    }
  },
  async getPlan(ctx, params) {
    try {
      const response = await api.getPlan(params);
      ctx.commit("getPlanSuccess", {
        plan: response.data
      });
    } catch (error) {
      throw error;
    }
  },
  async updatePlan(ctx, params) {
    try {
      const response = await api.updatePlan(params);
      ctx.commit("updatePlanSuccess", {
        plan: response.data
      });
    } catch (error) {
      throw error;
    }
  },
  async getCompetitorEmbedded(ctx, params) {
    try {
      const response = await api.getCompetitorEmbedded(params);
      ctx.commit("getCompetitorEmbeddedSuccess", {
        competitor: response.data
      });
    } catch (error) {
      ctx.commit("getCompetitorEmbeddedFailed", {
        error: {
          companyId: params.companyId,
          error
        }
      });
      throw error;
    }
  },
  async getStudentEmbedded(ctx, params) {
    try {
      const response = await api.getStudentEmbedded(params);
      ctx.commit("getStudentEmbeddedSuccess", {
        student: response.data
      });
    } catch (error) {
      ctx.commit("getStudentEmbeddedFailed", {
        error: {
          studentId: params.studentId,
          error
        }
      });
      throw error;
    }
  },
  async getStudentJobHuntingTrendCollection(ctx, params) {
    try {
      const response = await api.getStudentJobHuntingTrendCollection(params);
      ctx.commit("getStudentJobHuntingTrendCollectionSuccess", {
        studentJobHuntingTrendCollection: response.data
      });
    } catch (error) {
      throw error;
    }
  },
  async createCompetitor(ctx, params) {
    try {
      const response = await api.createCompetitor(params);
      ctx.commit("createCompetitorSuccess", {
        competitor: response.data
      });
    } catch (error) {
      ctx.commit("createCompetitorFailed", {
        error: {
          companyId: params.company.id,
          error
        }
      });
    }
  },
  async deleteCompetitor(ctx, params) {
    try {
      await api.deleteCompetitor(params);
      ctx.commit("deleteCompetitorSuccess", {
        competitorId: params.competitorId
      });
    } catch (error) {
      throw error;
    }
  },
  async deleteUniversity(ctx, params) {
    try {
      await api.deleteUniversity(params);
      ctx.commit("deleteUniversitySuccess", {
        studentId: params.studentId
      });
    } catch (error) {
      throw error;
    }
  },
  async createUniversity(ctx, params) {
    try {
      const response = await api.createUniversity(params);
      ctx.commit("createUniversitySuccess", {
        university: response.data
      });
    } catch (error) {
      throw error;
    }
  },
  async updateUniversity(ctx, params) {
    try {
      const response = await api.updateUniversity(params);
      ctx.commit("updateUniversitySuccess", {
        university: response.data
      });
      ctx.dispatch("getStudentEmbedded", {
        partnerId: params.partnerId,
        planId: params.planId,
        studentId: params.studentId
      });
    } catch (error) {
      throw error;
    }
  }
};

export default actions;
